import * as types from '../constants/action.types';
import { IAction } from '../constants/action';
import { downloadsState } from '../constants/initial-state';

export default function downloadsReducer(state = downloadsState, action: IAction) {
    switch (action.type) {
        case (types.DOWNLOADS_REQUESTED):
            return Object.assign({}, state, { isFetching: true });
        case (types.DOWNLOADS_RETRIEVED):
            const data = action.data instanceof Array ? action.data : [];
            return Object.assign({}, state, { isFetching: false, loaded: true, items: data, total: data.length });
        case (types.DOWNLOADS_FAILED):
            return Object.assign({}, state, { isFetching: false, error: action.data });
        case (types.DOWNLOADS_CHANGE_PAGE):
            return Object.assign({}, state, { page: action.data });
        case (types.USER_LOGGED_OUT):
            return downloadsState;
        default: return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/downloads.reducer.ts